import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { FeatureFlagManagerService } from '@app/infrastructure/feature-flag-manager/feature-flag-manager.service';
import { AppRouteHelper } from '@shared/helpers/app-route.helper';
import { Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { LDFlagSet } from 'launchdarkly-js-client-sdk';
import { FEATURE_FLAGS } from '@app/infrastructure/feature-flag-manager/feature-flag-list';
import { ZestyDiskRoutes } from '@modules/ebs/ebs.interfaces';

@Injectable({
	providedIn: 'root',
})
export class NewUserProfileGuard implements CanActivate {
	constructor(private router: Router, private featureFlagManager: FeatureFlagManagerService) {}

	public canActivate(next: ActivatedRouteSnapshot): Observable<boolean> {
		const flagKey: string = FEATURE_FLAGS.ENABLE_NEW_USER_PROFILE_MICRO_FRONTEND;

		return this.featureFlagManager.flags$.pipe(
			take(1),
			map((flags) => {
				if (flags[flagKey]) {
					this.router.navigate([AppRouteHelper.userProfile]);
				}

				return true;
			}),
		);
	}
}
